__turbopack_context__.v({
  "className": "noto_kufi_arabic_d95cd72e-module__zAmozW__className",
});
